<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="login-view">
    <div class="login-wrap">
      <div class="login-header">
        <div class="icon-ajuntament" />
      </div>
      <div class="login-body">
        <h2 class="login-title">{{ $t('login') }}</h2>
        <div class="login-input-wrapper">
          <label class="login-input-label">{{ $t('email') }}</label>
          <input
            v-model="loginInput"
            class="login-input"
            :class="arrayErrorInputs.indexOf('email') !== -1 && 'error'"
            type="text"
            :placeholder="$t('email_ex')"
          >
        </div>
        <div class="login-input-wrapper">
          <label class="login-input-label">{{ $t('password') }}</label>
          <input
            v-model="passwordInput"
            class="login-input"
            type="password"
            :class="arrayErrorInputs.indexOf('password') !== -1 && 'error'"
            :placeholder="$t('password_ex')"
          >
          <div class="forgot-password" @click="routeChange('Forgot')">{{ $t('password_forgot') }}</div>
        </div>
        <p v-if="arrayErrorInputs.indexOf('login') !== -1" class="error-login">
          {{ $t('error_login') }}
        </p>
        <p v-if="arrayErrorInputs.indexOf('blocked') !== -1" class="error-login">
          {{ $t('user_blocked') }}
        </p>
      </div>
      <div class="login-footer">
        <label class="login-checkbox-label">
          <input
            v-model="loginChecked"
            class="login-checkbox-input"
            type="checkbox"
            name="check"
          >
          {{ $t('session_remember') }}
        </label>
        <div class="login-btn" @click="validateAndLogin">{{ $t('login') }}</div>
        <div class="login-not-member">
          {{ $t('login_advantages') }}
          <a class="link" href="/help-users/funcionalidades">{{ $t('here') }}</a>
        </div>
        <div class="login-not-member">
          {{ $t('not_member') }}
          <span class="link" @click="routeChange('Register')">{{ $t('want_register') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginUser } from '@/services/user-api'
export default {
  components: {},
  props: {},
  data() {
    return {
      loginInput: '',
      passwordInput: '',
      loginChecked: '',
      arrayErrorInputs: [],
      validLogin: true,
    }
  },
  computed: {},
  watch: {
    loginInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('login') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('login'), 1)
      }
      if (this.arrayErrorInputs.indexOf('blocked') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('blocked'), 1)
      }
      if (this.arrayErrorInputs.indexOf('email') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('email'), 1)
      }
    },
    passwordInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('login') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('login'), 1)
      }
      if (this.arrayErrorInputs.indexOf('blocked') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('blocked'), 1)
      }
      if (this.arrayErrorInputs.indexOf('password') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('password'), 1)
      }
    },
  },
  methods: {
    /**
     * Update the current route with new params if current page is different
     * @param {String} routeName Name of page that user want's to navigate
     * @public This is a public method
     */
    routeChange(routeName) {
      if (this.$route.name !== routeName) this.$router.push({ name: routeName })
    },
    validateAndLogin() {
      let reg = /[^\s]*@[a-z0-9.-]*/i
      if (
        (this.loginInput === '' || !reg.test(this.loginInput)) &&
        this.arrayErrorInputs.indexOf('email') === -1
      ) {
        this.arrayErrorInputs.push('email')
      }
      if (this.passwordInput === '' && this.arrayErrorInputs.indexOf('password') === -1) {
        this.arrayErrorInputs.push('password')
      }

      if (this.arrayErrorInputs.length === 0) {
        let self = this
        loginUser(this.loginInput, this.passwordInput, this.loginChecked)
          .then(resp => {
            if (resp.code === 200) {
              self.$store.dispatch('createUser', resp).then(() => this.routeChange('Profile'))
            }
          })
          .catch(err => {
            if (
              err.response.data.error === 'Invalid credentials' &&
              this.arrayErrorInputs.indexOf('login') === -1
            ) {
              this.arrayErrorInputs.push('login')
            } else if (err.response.data.error === 'User not validated') {
              self.$store
                .dispatch('saveUserEmail', this.loginInput)
                .then(() => this.routeChange('Invalid'))
            } else if (err.response.data.error === 'User blocked') {
              this.arrayErrorInputs.push('blocked')
            }
          })
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.login-view
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  padding: vw(30px)
  min-height: "calc(100vh - %s - %s - %s)" % ($header-height $subheader-height $footer-height)
  background-color: $very-light-grey

.login-wrap
  padding: vh(20px) vw(24px)
  width: vw(380px)
  border-radius: 8px
  background-color: #fff
  box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)

  .error-login
    m-font-size(15, 20)
    display: flex
    justify-content: center
    width: 100%
    color: $warning
    font-weight: 600
    margin-block-end: 0
    margin-block-start: 0.25em

.login-header
  display: flex
  justify-content: space-between
  margin-bottom: vh(48px)

  .icon-ajuntament
    width: 176px
    height: 45px
    background-image: url("~@/assets/logos/logo-ajuntament-barcelona-rounded.svg")
    background-position: center center
    background-size: cover
    background-repeat: no-repeat

    .mobile &
      width: 176px
      height: 45px

.login-title
  m-font-size(32, 45)
  margin-block-start: 0
  margin-block-end: vh(20px)
  color: $base-font-color
  font-weight: 600

.login-input-wrapper
  margin-bottom: vh(36px)
  width: 100%

.login-input-label
  m-font-size(14, 20)
  display: block
  margin-bottom: vh(8px)
  color: $grey

.login-input
  position: relative
  padding: 0
  padding-right: vw(12px)
  padding-left: vw(12px)
  width: 100%
  height: vh(48px)
  outline: none
  border: 1px solid $grey
  border-radius: 4px
  background-color: $light-grey
  color: #000
  font-weight: 600

  &::placeholder
    color: $grey
    font-weight: 400

  &.error
    border: 2px solid $warning
    

  .mobile &
    height: vw(40px)

.forgot-password
  m-font-size(12, 22)
  display: inline-block
  margin-top: vh(8px)
  padding: vh(5px) vw(10px)
  color: $corporate_color
  font-weight: 400
  cursor: pointer

  &:hover
    text-decoration: underline

.login-footer
  margin-top: vh(48px)

.login-btn
  m-font-size(14, 20)
  display: flex
  justify-content: center
  align-items: center
  margin-bottom: vh(20px)
  padding: vw(10px)
  width: 100%
  border-radius: 4px
  background-color: #000
  color: #fff
  cursor: pointer

.login-checkbox-label
  m-font-size(14, 18)
  display: flex
  align-items: center
  margin-bottom: vh(16px)
  color: $grey-dark
  cursor: pointer
  gap: vw(10px)

.login-checkbox-input
  margin: vw(2px)
  cursor: pointer

.login-not-member
  m-font-size(12, 22)

  .link
    color: $corporate_color
    cursor: pointer

    &:hover
      text-decoration: underline
</style>